"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_USER_PREFERENCES = void 0;
exports.DEFAULT_USER_PREFERENCES = {
    emailEnabled: true,
    pushNotificationsEnabled: true,
};
